import { Modal } from 'cpool-components/general/Modal';
import { useTranslation } from 'react-i18next';

import { hasAnyMailTrigger } from './hasAnyMailTrigger';
import { SubstatusChangeForm, type SubstatusChangeFormProps } from './SubstatusChangeForm';
import { useLoanRequestStatusesWithMailTrigger } from '~/features/leadDetails/hooks/useLoanRequestStatusesWithMailTrigger';

export type { StatusWithSubStatuses, SubstatusChangeFormProps } from './SubstatusChangeForm';
export { SubstatusChangeForm } from './SubstatusChangeForm';

type Props = Omit<SubstatusChangeFormProps, 'withHeader'>;

export const SubstatusChangeModal: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const { data: statusesWithMailTrigger } = useLoanRequestStatusesWithMailTrigger();
    const showPreview = hasAnyMailTrigger(statusesWithMailTrigger, props.currentStatus);

    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
            title={t('STATUS.SET_SUBSTATUS')}
            panelClassName={showPreview ? 'w-[900px] max-w-[calc(100vw-2rem)]' : 'w-[362px]'}
        >
            <SubstatusChangeForm {...props} />
        </Modal>
    );
};
